import * as React from 'react';
import { QuestionMarkCircleIcon } from '@mentimeter/ragnar-visuals';
import type { UspT } from '@mentimeter/plans-content';
import { Box } from '@mentimeter/ragnar-ui/box';
import { MetaTextValueOriented } from './MetaTextValueOriented';

interface UspsValueOrientedProps {
  disabled?: boolean;
  usps: Array<UspT | false>;
}

export const UspsValueOriented = ({
  disabled,
  usps,
}: UspsValueOrientedProps) => {
  return (
    <Box
      width="100%"
      extend={({ theme }) => ({
        opacity: disabled ? theme.opacity['disabled'] : 1,
      })}
    >
      <Box
        alignItems="baseline"
        display="grid"
        columnGap="space1.5"
        rowGap="space4"
        gridTemplateColumns="20px 1fr"
      >
        {usps.filter(isDefined).map((usp) => {
          const Icon = usp.icon;
          return (
            <React.Fragment key={usp.text}>
              <Box top="3px">{Icon && <Icon />}</Box>
              <Box>
                <MetaTextValueOriented
                  meta={usp}
                  fontSize="100"
                  fontWeight="semiBold"
                  color="text"
                  iconTrailing={usp.tooltips && <TooltipIcon />}
                />
                {usp.subheading && (
                  <MetaTextValueOriented
                    targetUnderline={false}
                    meta={usp.subheading}
                    fontSize="100"
                    color="textWeaker"
                    mt="space0.5"
                    iconTrailing={usp.subheading.tooltips && <TooltipIcon />}
                  />
                )}
              </Box>
            </React.Fragment>
          );
        })}
      </Box>
    </Box>
  );
};

function TooltipIcon() {
  return (
    <Box display="inline-flex">
      <QuestionMarkCircleIcon size={0} color="textWeaker" />
    </Box>
  );
}

function isDefined<T>(argument: T | undefined | false): argument is T {
  return Boolean(argument);
}
